import React from 'react';

import Img from 'retired/Img';
import waitlistEmptySvg from 'assets/deed/loupe.svg';

export const WaitlistEmptyContent = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      paddingTop: 60,
      paddingBottom: 60,
    }}
  >
    <Img src={waitlistEmptySvg} />
    <div>The waitlist is empty</div>
  </div>
);
